import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../../@types/RootState';

type SegmentData = {
  type: string;
  value: string;
};

export type RulesPageFiltersValueState = Record<string, string[]> & {
  searchMechanismType?: string;
  ruleStatus?: string;
  rulePriceType?: string;
  sensibilityType?: SegmentData[];
};

export type RulesPageFiltersValueKey = keyof RulesPageFiltersValueState;

export type RulesPageFiltersValueValue = RulesPageFiltersValueState[RulesPageFiltersValueKey];

const initialState: RulesPageFiltersValueState = {};

const slice = createSlice({
  name: 'ipa.strategy.rules.filters.value',
  initialState,
  reducers: {
    RESET_RULES_PAGE_FILTERS_VALUE: () => initialState,
    SET_RULES_PAGE_FILTERS_VALUE_BY_KEY: (
      state,
      action: PayloadAction<{
        key: RulesPageFiltersValueKey;
        value: RulesPageFiltersValueValue;
      }>,
    ) => {
      return { ...state, [action.payload.key]: action.payload.value };
    },
  },
});

export const selectorRulesPageFiltersValue = (state: RootState) => state.ipa.strategy.rules.filters.value;

export const { RESET_RULES_PAGE_FILTERS_VALUE, SET_RULES_PAGE_FILTERS_VALUE_BY_KEY } = slice.actions;

export default slice.reducer;
